import React, { useEffect, useState } from 'react';
import './App.css';
import DraftB from './components/DraftB';
import BlogPost from './components/BlogPost';

function parseRoute() {
  const hash = window.location.hash.slice(1);
  if (hash.startsWith('/blog/')) {
    return { page: 'blog', slug: hash.replace('/blog/', '') };
  }
  return { page: 'home' };
}

function App() {
  const [route, setRoute] = useState(parseRoute);

  useEffect(() => {
    const onHash = () => setRoute(parseRoute());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  return (
    <div className="app-wrap">
      {route.page === 'blog' ? <BlogPost slug={route.slug} /> : <DraftB />}
    </div>
  );
}

export default App;
